import { createAction } from '@reduxjs/toolkit'

import { KpiVariable } from 'types/GlobalKpiVariable'

// tryGetAllKpiVariables
export const getAll = createAction('get_kpi_variables')
export const getAllSuccess = createAction<{
  data: KpiVariable[]
}>('get_kpi_variables_success')
export const getAllFailed = createAction('get_kpi_variables_failed')

// tryPutSortedKpiVariables
export const putSort = createAction('put_sorted_kpi_variables')
export const putSortSuccess = createAction<{
  data: KpiVariable[]
}>('put_sorted_kpi_variables_success')
export const putSortFailed = createAction('put_sorted_kpi_variables_failed')

// tryCreateKpiVariable
export const create = createAction('create_kpi_variable')
export const createSuccess = createAction<{
  data: KpiVariable
}>('create_kpi_variable_success')
export const createFailed = createAction('create_kpi_variable_failed')

// tryUpdateKpiVariable
export const update = createAction('update_kpi_variable')
export const updateSuccess = createAction<{
  data: KpiVariable
}>('update_kpi_variable_success')
export const updateFailed = createAction('update_kpi_variable_failed')

// tryDeleteKpiVariable
export const destroy = createAction('delete_kpi_variable')
export const destroySuccess = createAction<{
  id: string
}>('delete_kpi_variable_success')
export const destroyFailed = createAction('delete_kpi_variable_failed')
